import React from "react";
import { AppBar, Toolbar, Button, Typography, Box } from "@mui/material";

const TopNavigation = ({
  onPricingClick,
  onContactClick,
  onSignInClick,
  onSignUpClick,
  showSignIn = true,
  logoClickHandler,
}) => {
  const handleLogoClick = () => {
    if (logoClickHandler) {
      logoClickHandler();
    } else {
      window.location.reload();
    }
  };

  return (
    <AppBar
      position="static"
      color="default"
      elevation={0}
      sx={{ bgcolor: "#fff", borderBottom: "1px solid #e0e0e0" }}
    >
      <Toolbar sx={{ justifyContent: "space-between" }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box
            component="img"
            src="/logo.png"
            alt="Comply Extractor"
            sx={{ height: 32, mr: 1, cursor: "pointer" }}
            onClick={handleLogoClick}
          />
          <Typography variant="h6" sx={{ color: "#222", fontWeight: 700 }}>
            {/* <span style={{ color: '#2aa7e0' }}>comply</span><span style={{ color: '#222' }}>extractor</span> */}
          </Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Button
            color="inherit"
            sx={{ color: "#2aa7e0", fontWeight: 500, textTransform: "none" }}
            onClick={onPricingClick}
          >
            Pricing
          </Button>
          <Button
            color="inherit"
            sx={{ color: "#2aa7e0", fontWeight: 500, textTransform: "none" }}
            onClick={onContactClick}
          >
            Contact Us
          </Button>
          {showSignIn && (
            <Button
              color="inherit"
              sx={{ color: "#2aa7e0", fontWeight: 500, textTransform: "none" }}
              onClick={onSignInClick}
            >
              Sign In
            </Button>
          )}
          <Button
            variant="contained"
            className="free-trial-btn"
            sx={{
              bgcolor: "#F2AE33 !important",
              color: "#fff !important",
              fontWeight: 700,
              borderRadius: 2,
              px: 3,
              textTransform: "none !important",
              "&:hover": { bgcolor: "#e6a200 !important" },
              "&.MuiButton-root": {
                bgcolor: "#F2AE33 !important",
                color: "#fff !important",
              },
            }}
            onClick={onSignUpClick}
          >
            {showSignIn ? "Free Trial" : "Sign Up"}
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default TopNavigation;
